<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div *ngIf="success || error" appMargin marginY="10px">
  <esl-message-toast
    [(message)]="success"
    [messageType]="'success'"
  ></esl-message-toast>
  <esl-message-toast [(message)]="error"></esl-message-toast>
</div>
<div
  class="ui segment content"
  style="border: none; box-shadow: none"
  [ngClass]="{ loading: pending }"
>
  <form class="ui form">
    <div class="ui left icon input">
      <i class="icon search"></i>
      <input type="search" placeholder="search" [formControl]="search" />
    </div>

    <div class="users">
      <div>
        <sui-checkbox
          name="check"
          (checkChange)="toggleAllUsers($event)"
          [(ngModel)]="allUsersSelected"
        ></sui-checkbox>
        Select All
      </div>
      <div
        class="field"
        *ngFor="let user of unselectedUsers; trackBy: trackByUserId"
      >
        <div class="user">
          <div class="user_details">
            <sui-checkbox
              name="user"
              (checkChange)="checkChange(user, $event)"
              [(ngModel)]="user.checked"
            ></sui-checkbox>
            <img
              *ngIf="!user.image"
              src="../../../../../assets/avatar/1.jpg"
              style="width: 60px; height: 60px; border-radius: 100%"
            />
            <img
              *ngIf="user.image"
              src="{{ user.image }}"
              style="width: 60px; height: 60px; border-radius: 100%"
            />
            <div class="name">
              <div class="ui tiny header">{{ user?.name || "-" }}</div>
              <div
                *ngIf="user?.active"
                class="ui tiny green circular label"
                style="background: #44c4a1"
              >
                ACTIVE
              </div>
              <div
                *ngIf="!user?.active"
                class="ui tiny green circular label"
                style="background: #44c4a1"
              >
                INACTIVE
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
  <div class="actions" style="border: none">
    <button class="ui primary basic button" (click)="modal.deny(undefined)">
      Cancel
    </button>
    <button
      class="ui primary button"
      [disabled]="pending || isButtonDisabled()"
      (click)="submit()"
    >
      Add User to Sub-topic
    </button>
  </div>
</div>
